<template>
    <v-card style="overflow-x: scroll">
        <v-card-text>
            <experiment-data
                v-if="experimentData"
                :experimentData="experimentData"
                :protocolId="protocol.code"
                :customEntityList="entityList"
                ref="experimentDataComponent"
            />
        </v-card-text>
        <v-card-actions>
            <v-btn v-if="isBackButtonAvailable()" @click="back">Back</v-btn>
            <v-btn @click="cancel">Close</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { defineComponent } from "vue";

import ExperimentData from "./ExperimentData.vue";
import { legacyExperimentAPI } from "@/services/api.services";
import { withLoadingScreen } from "@/lib/loading";
import _ from "lodash";
import {
    fetchAllEntityDataOTForExperimentCode,
    fetchEntitySchemasByProtocolCode,
} from "@/lib/legacyThingUtils";

export default defineComponent({
    name: "legacy-thing-instance-ot-data",
    components: { ExperimentData },

    props: {
        protocol: {
            type: Object,
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            experimentData: null,
            entityList: [],
        };
    },

    async mounted() {
        await withLoadingScreen(async () => {
            const experimentData = await legacyExperimentAPI.fetchExperimentByCode(
                this.experiment.code
            );
            this.entityList = await fetchEntitySchemasByProtocolCode(this.protocol.code);
            const siteTimeZone = this.experiment.siteTimeZone || "UTC";
            experimentData.mangoData = await fetchAllEntityDataOTForExperimentCode(
                this.experiment.code,
                siteTimeZone
            );

            this.experimentData = experimentData;
        });
    },

    methods: {
        isBackButtonAvailable() {
            return _.get(this, "$route.params.date");
        },
        back() {
            // Clear the date from the experiment data component
            this.$router.push({
                path: `/experiment/${this.$route.params.code}/${this.$route.params.protocolId}`,
            });
            this.$refs.experimentDataComponent.reloadData();
        },
        cancel() {
            // clear the router
            this.$router.push({
                path: `/experiment/${this.$route.params.code}/${this.$route.params.protocolId}`,
            });
            this.$emit("close");
        },
    },
});
</script>
